import React from 'react';
import { Breadcrumb, Label } from 'react-bootstrap';
import { connect } from 'react-redux';

export class BreadCrumbs extends React.Component {

    render() {                                        
        var items = [];        
        if (this.props.application.activeProposal){
            items.push({
                name : "Proposals",
                link : "/proposals"
            });

            items.push({                              
                name : this.props.application.activeProposal.name,
                link : "/sessions/proposal/" + this.props.application.activeProposal.name,
            });

            if (this.props.application.activeSession){
                items.push({                               
                    name : this.props.application.activeSession.title               
                });
            }
            else{
                items.push({                               
                    name : "Sessions"
                });
            }                       
        }
        else{
            items = this.props.breadcrumbsList.items;
        }
        /** breadCrumbsSize is used to mark as active the latest item in the list */
        var breadCrumbsSize = items.length;
       
        return (<Breadcrumb style={{  marginTop: 65, borderBotton: '1px solid #f2f2f2', fontSize: '14px' }}>

            {items.map(function (breadcrumb, i) {
                
                if (i === 0) {
                    return <Breadcrumb.Item key={i} style={{ marginLeft: '40px' }} href={breadcrumb.link}> {breadcrumb.name} </Breadcrumb.Item>;
                }
                if (breadCrumbsSize === (i + 1)) {
                    
                    return <Breadcrumb.Item  key={i} active href={breadcrumb.link}>
                        <Label style={{ fontSize: '12px' }}>{breadcrumb.badge}</Label> {breadcrumb.name} </Breadcrumb.Item>;
                }
                
                return <Breadcrumb.Item  key={i} href={breadcrumb.link}> {breadcrumb.name} </Breadcrumb.Item>;

            })}
        </Breadcrumb>)
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,      
        application : state.application                      
    };
}

function mapDispatchToProps(dispatch) {   
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BreadCrumbs);







// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/BreadCrumbs.js